import uk from './locales/uk.json'
import en from './locales/en.json'

export default defineI18nConfig(() => ({
  legacy: false,
  locale: 'uk',
  globalInjection: true,
  messages: {
    "uk": uk,
    "en": en,
  },
  fallbackWarn: false,
  missingWarn: false,
}))